import { c as _c } from "react/compiler-runtime";
import { IcoBook16, IcoEye16, IcoFileText16, IcoFingerprint16, IcoInfo16, IcoSearch16, IcoShield16, IcoSparkles16, IcoWand16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import type { ActionPillConfig } from '../../components/action-pills';
import { buildAgentTemplates, isTemplateBackedAgentId, type TemplateBackedAgentId } from '../../data/agent-templates';
import { buildInvestigationTemplates } from '../../data/templates';
export type AskPercyVariant = 'full' | 'investigate' | 'agentBuilder' | 'playbookList' | 'playbookDetail';
export const usePills = (variant, onSelect, onCreateFromTemplate) => {
  const $0 = _c(53);
  const {
    t
  } = useTranslation("ask-percy");
  if (!variant) {
    return null;
  }
  if (variant === "agentBuilder") {
    let t0;
    if ($0[0] !== onSelect || $0[1] !== t) {
      const icons = {
        review: IcoSparkles16,
        missing: IcoSearch16,
        rules: IcoShield16
      };
      t0 = (["review", "missing", "rules"] as const).map(key => {
        const prompt = t($ => $.actionPills.agentBuilder[key]);
        return {
          kind: "action",
          id: `agent_builder_${key}`,
          label: prompt,
          icon: icons[key],
          prompt,
          onSelect
        };
      });
      $0[0] = onSelect;
      $0[1] = t;
      $0[2] = t0;
    } else {
      t0 = $0[2];
    }
    return t0;
  }
  if (variant === "playbookList") {
    let t0;
    if ($0[3] !== onSelect || $0[4] !== t) {
      const icons_0 = {
        create: IcoWand16,
        recommend: IcoSearch16,
        learn: IcoBook16
      };
      t0 = (["create", "recommend", "learn"] as const).map(key_0 => {
        const prompt_0 = t($_0 => $_0.actionPills.playbookList[key_0]);
        return {
          kind: "action",
          id: `playbook_list_${key_0}`,
          label: prompt_0,
          icon: icons_0[key_0],
          prompt: prompt_0,
          onSelect
        };
      });
      $0[3] = onSelect;
      $0[4] = t;
      $0[5] = t0;
    } else {
      t0 = $0[5];
    }
    return t0;
  }
  if (variant === "playbookDetail") {
    let t0;
    if ($0[6] !== onSelect || $0[7] !== t) {
      const icons_1 = {
        explain: IcoInfo16,
        review: IcoSparkles16,
        gaps: IcoSearch16
      };
      t0 = (["explain", "review", "gaps"] as const).map(key_1 => {
        const prompt_1 = t($_1 => $_1.actionPills.playbookDetail[key_1]);
        return {
          kind: "action",
          id: `playbook_${key_1}`,
          label: prompt_1,
          icon: icons_1[key_1],
          prompt: prompt_1,
          onSelect
        };
      });
      $0[6] = onSelect;
      $0[7] = t;
      $0[8] = t0;
    } else {
      t0 = $0[8];
    }
    return t0;
  }
  let t0;
  if ($0[9] !== t) {
    t0 = t(_temp);
    $0[9] = t;
    $0[10] = t0;
  } else {
    t0 = $0[10];
  }
  let t1;
  if ($0[11] !== t) {
    t1 = buildInvestigationTemplates(t);
    $0[11] = t;
    $0[12] = t1;
  } else {
    t1 = $0[12];
  }
  let t2;
  if ($0[13] !== onSelect) {
    t2 = template => onSelect(template.prompt);
    $0[13] = onSelect;
    $0[14] = t2;
  } else {
    t2 = $0[14];
  }
  let t3;
  if ($0[15] !== t0 || $0[16] !== t1 || $0[17] !== t2) {
    t3 = {
      kind: "templates",
      id: "start_investigation",
      label: t0,
      icon: IcoShield16,
      templates: t1,
      onSelect: t2
    };
    $0[15] = t0;
    $0[16] = t1;
    $0[17] = t2;
    $0[18] = t3;
  } else {
    t3 = $0[18];
  }
  const investigate = t3;
  if (variant === "investigate") {
    let t4;
    if ($0[19] !== investigate) {
      t4 = [investigate];
      $0[19] = investigate;
      $0[20] = t4;
    } else {
      t4 = $0[20];
    }
    return t4;
  }
  let t4;
  if ($0[21] !== t) {
    t4 = t(_temp2);
    $0[21] = t;
    $0[22] = t4;
  } else {
    t4 = $0[22];
  }
  let t5;
  if ($0[23] !== t) {
    t5 = buildAgentTemplates(t);
    $0[23] = t;
    $0[24] = t5;
  } else {
    t5 = $0[24];
  }
  let t6;
  if ($0[25] !== onCreateFromTemplate || $0[26] !== onSelect) {
    t6 = template_0 => onCreateFromTemplate && isTemplateBackedAgentId(template_0.id) ? onCreateFromTemplate(template_0.id) : onSelect(template_0.prompt);
    $0[25] = onCreateFromTemplate;
    $0[26] = onSelect;
    $0[27] = t6;
  } else {
    t6 = $0[27];
  }
  let t7;
  if ($0[28] !== t4 || $0[29] !== t5 || $0[30] !== t6) {
    t7 = {
      kind: "templates",
      id: "create_agent",
      label: t4,
      icon: IcoFingerprint16,
      templates: t5,
      onSelect: t6
    };
    $0[28] = t4;
    $0[29] = t5;
    $0[30] = t6;
    $0[31] = t7;
  } else {
    t7 = $0[31];
  }
  let t8;
  if ($0[32] !== t) {
    t8 = t(_temp3);
    $0[32] = t;
    $0[33] = t8;
  } else {
    t8 = $0[33];
  }
  let t9;
  if ($0[34] !== t) {
    t9 = t(_temp4);
    $0[34] = t;
    $0[35] = t9;
  } else {
    t9 = $0[35];
  }
  let t10;
  if ($0[36] !== onSelect || $0[37] !== t8 || $0[38] !== t9) {
    t10 = {
      kind: "action",
      id: "summarize_entity",
      label: t8,
      icon: IcoEye16,
      prompt: t9,
      onSelect
    };
    $0[36] = onSelect;
    $0[37] = t8;
    $0[38] = t9;
    $0[39] = t10;
  } else {
    t10 = $0[39];
  }
  let t11;
  if ($0[40] !== t) {
    t11 = t(_temp5);
    $0[40] = t;
    $0[41] = t11;
  } else {
    t11 = $0[41];
  }
  let t12;
  if ($0[42] !== t) {
    t12 = t(_temp6);
    $0[42] = t;
    $0[43] = t12;
  } else {
    t12 = $0[43];
  }
  let t13;
  if ($0[44] !== onSelect || $0[45] !== t11 || $0[46] !== t12) {
    t13 = {
      kind: "action",
      id: "generate_report",
      label: t11,
      icon: IcoFileText16,
      prompt: t12,
      onSelect
    };
    $0[44] = onSelect;
    $0[45] = t11;
    $0[46] = t12;
    $0[47] = t13;
  } else {
    t13 = $0[47];
  }
  let t14;
  if ($0[48] !== investigate || $0[49] !== t10 || $0[50] !== t13 || $0[51] !== t7) {
    t14 = [t7, investigate, t10, t13];
    $0[48] = investigate;
    $0[49] = t10;
    $0[50] = t13;
    $0[51] = t7;
    $0[52] = t14;
  } else {
    t14 = $0[52];
  }
  return t14;
};
function _temp($_2) {
  return $_2.actionPills.investigate;
}
function _temp2($_3) {
  return $_3.actionPills.createAgent;
}
function _temp3($_4) {
  return $_4.actionPills.summarize;
}
function _temp4($_5) {
  return $_5.actionPills.directActions.summarize.prompt;
}
function _temp5($_6) {
  return $_6.actionPills.generateReport;
}
function _temp6($_7) {
  return $_7.actionPills.directActions.generateReport.prompt;
}